import { make } from 'vuex-pathify';


const namespaced = true;
const state = {
    deviceId: "", // "abcdefghi", done
    deviceName: "", // "Zaeems IPhone", done
    deviceOSAndVersion: "", // "IOS 18.1", done
    model: "", // "Iphone 16 Pro Max", done
    brand: "", // "Apple", done
    manufacturer: "Not Available", // "Apple",
    publicIP: "", // "203.99.61.130", done
    locationName: "", // "New York, United States", done
    locationLat: 0, // 37.785834, done
    locationLong: 0, // -122.406417 done
};
const getters = { ...make.getters(state) };
const actions = { ...make.actions(state) };
const mutations = { ...make.mutations(state) };

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
